import { useFlag } from '@calendly/feature-check-react'
import { useContext } from 'react'

import {
  getDashboardEventIdForInvitees,
  shouldSkipDashboardInviteesForSupergraph
} from 'components/meetings/utils/get_dashboard_event_id_for_invitees'

import { SearchMeetingDetailContext } from '../../../meeting_detail_context'

export const useInviteesEventId = (event) => {
  const searchMeeting = useContext(SearchMeetingDetailContext)
  const isGroup = event.eventType?.kind === 'group'
  const supergraphMeetingsPage = useFlag('sa_meetings_page_with_supergraph', false)
  const eventId = supergraphMeetingsPage
    ? getDashboardEventIdForInvitees(event)
    : (event.id || event.uuid)
  const skipUuidUntilDashEventId = shouldSkipDashboardInviteesForSupergraph(
    supergraphMeetingsPage,
    eventId
  )
  const skipForSearchRail = Boolean(
    isGroup
      && eventId
      && searchMeeting?.dashboardInviteeFetchUnblocked === false
  )

  const skip = !eventId || !isGroup || skipForSearchRail || skipUuidUntilDashEventId

  return { eventId, skip, isGroup }
}
